// Pending-line counts + confirm-review wiring for Manufacturing Models.
import { useCallback, useEffect, useRef, useState } from "react";
import { listManufacturingRecipePendingLineCounts } from "@/lib/manufacturingClient";
import { useManufacturingModelsConfirmReview } from "./useManufacturingModelsConfirmReview";

export function useManufacturingModelsPendingReview(opts: {
  enabled: boolean;
  recipeCount: number;
  navTick: number;
  onAfterConfirm: () => void;
  onError: (msg: string) => void;
}) {
  const [pendingCounts, setPendingCounts] = useState<Record<string, number>>({});
  const afterConfirmRef = useRef(opts.onAfterConfirm);
  const onErrorRef = useRef(opts.onError);
  afterConfirmRef.current = opts.onAfterConfirm;
  onErrorRef.current = opts.onError;

  const refreshPendingCounts = useCallback(async () => {
    if (!opts.enabled) return;
    const r = await listManufacturingRecipePendingLineCounts();
    if (r.ok) setPendingCounts(r.data.counts);
  }, [opts.enabled]);

  useEffect(() => {
    void refreshPendingCounts();
  }, [refreshPendingCounts, opts.recipeCount, opts.navTick]);

  const handleReviewConfirmed = useCallback(() => {
    void refreshPendingCounts();
    afterConfirmRef.current();
  }, [refreshPendingCounts]);

  const confirmReview = useManufacturingModelsConfirmReview({
    onDone: handleReviewConfirmed,
    onError: (msg) => onErrorRef.current(msg),
  });

  return {
    pendingCounts,
    refreshPendingCounts,
    confirmReview,
    handleReviewConfirmed,
  };
}
